import { TagInput } from 'vue-bootstrap';
import Vue from 'vue';

/**
 * The tags input module abstracts away the underlying implementation detail,
 * and allows us to setup automatic bindings for inputs:
 *
 *  input.tags-input
 *
 * Usage:
 *    import tagsInput from './tags-input.js';
 *    tagsInput.setup($('.tags-input'));
 */
const tagsInput = {
	setup(elements) {
		for (let i = 0; i < elements.length; i++) {
			new Vue({
				el: elements[i],
				name: 'TagsInputApp' + i,
				components: {
					'tag-input': TagInput,
				},
			});
		}
	},
};

export default tagsInput;
